import { InteractionRequiredAuthError, type IPublicClientApplication } from '@azure/msal-browser';
import { apiTokenRequest } from './config';

/**
 * Access token for the API, refreshed silently when it expires.
 *
 * acquireTokenSilent uses the cached refresh token, falling back to a hidden
 * iframe. Only when Entra genuinely needs the user (expired session, changed
 * password, new consent) do we surface a redirect — anything else would bounce
 * people out of the app for no reason.
 */
export async function getApiAccessToken(
  instance: IPublicClientApplication,
): Promise<string | null> {
  const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0];
  if (!account) {
    return null;
  }

  try {
    const result = await instance.acquireTokenSilent({ ...apiTokenRequest, account });
    return result.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await instance.acquireTokenRedirect({ ...apiTokenRequest, account });
      return null;
    }
    throw error;
  }
}
